<template>
  <AppSelect
    :items="ITEMS"
    :label="$tt('job_seniority')"
    :placeholder="$tt('select_seniority_years')"
  />
</template>

<script setup lang="ts">
import type { JobSeniority } from '~/types';

const ITEMS: JobSeniority[] = [
  '0-1', '2-5', '6-10', '11-19', '20+'
];
</script>